module.exports = __webpack_public_path__ + "static/media/PE.ab9f85be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/PE.svg
// module id = 336
// module chunks = 0